import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {FormFieldDeterminantRelationship} from "../../models/form-field-determinant-relationship";
import Helpers from "../../utils/helpers";

@Injectable()
export class FormFieldDeterminantControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) { }

  public getFormFieldDeterminantRelationsList(serviceId: string): Observable<FormFieldDeterminantRelationship[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formfields_determinant_relations") as Observable<FormFieldDeterminantRelationship[][]>;
  }

  public updateFormFieldDeterminants(serviceId: string, formFieldDeterminantRelations: FormFieldDeterminantRelationship) {
    Helpers.trimRecursiveObj(formFieldDeterminantRelations);
    const body = JSON.stringify(formFieldDeterminantRelations);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/formfields_determinant_relations", body);
  }
}
